module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('MainGameInfo', {
    ref: "MainGameView",
    on: {
      "showWXTips": _vm.showWXTips,
      "downLoad": _vm.downLoad
    }
  }), _vm._v(" "), _c('UserAuth', {
    ref: "UserAuthView",
    attrs: {
      "showKF": false
    },
    on: {
      "authSuc": _vm.authSuc
    }
  }), _vm._v(" "), _c('plistTips', {
    ref: "plistTipsView"
  }), _vm._v(" "), _c('wxTips', {
    ref: "wxTipsView"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb85514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LandingPage/game.vue
// module id = 336
// module chunks = 2